<template>
  <div class="myData">
    <div class="top" style="margin-bottom:0.1rem">
      <img src="../../../../assets/img/user/employee_icon.png" alt />
      <div class="t-content">
        <div @click="editName" style="display:flex">
          <span class="name">{{myDetail.realname}}</span>
          <van-icon name="edit" size="0.48rem" color="#31B158" />
        </div>
        <div>{{myDetail.mobile}}</div>
      </div>
      <div></div>
    </div>
    <!-- 弹框提示 -->
    <van-dialog v-model="showChangeName" title="请输入名称" show-cancel-button @confirm="handleConfirm">
      <div class="showChangeName_box">
        <input type="text" v-model="listQuery.realname" placeholder="请输入10位以内的名称" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { getUserData } from "@/api/layout/home";
import { edit_my_name } from "@/api/work/mine/myData";
export default {
  name: "myData",
  data() {
    return { showChangeName: false, listQuery: { realname: "" }, myDetail: "" };
  },
  created() {
    this.getList();
  },
  mounted() {},
  methods: {
    getList() {
      getUserData().then(res => {
        if (res.code == 200) {
          this.myDetail = res.data;
          this.listQuery.realname = res.data.realname;
        }
      });
    },
    //修改名字
    editName() {
      this.showChangeName = true;
      this.listQuery.realname =  this.myDetail.realname;
    },
    // 确定修改
    handleConfirm() {
      if (!this.listQuery.realname) {
        this.$toast("请输入名称！");
        return false;
      }
       if (this.listQuery.realname.length>10) {
        this.$toast("请输入10位以内的名称！");
        return false;
      }
      edit_my_name(this.listQuery).then(res => {
        if (res.code == 200) {
          this.$toast.success("修改成功");
          this.getList();
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.myData {
  position: relative;

  .name {
    display: inline-block;
    margin-right: 0.2rem;
  }
  .showChangeName_box {
    width: 90%;
    margin: 0.3rem auto;
    height: 0.8rem;
    border-radius: 0.1rem;
    border: 0.02rem solid #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    input {
      border: none;
      width: 95%;
      color: #333;
    }
  }
  .top {
    background-color: #fff;
    margin-top: 0.2rem;
    padding: 0.37rem 0.2rem;
    align-items: top;
    display: flex;
    justify-content: space-between;

    img {
      width: 0.92rem;
      height: 0.92rem;
    }
    .edit_name {
      width: 0.32rem;
      height: 0.32rem;
    }
    .t-content {
      width: 5.2rem;
      > div:first-child {
        font-size: 0.32rem;
      }
      > div:nth-child(2) {
        margin-top: 0.27rem;
        margin-bottom: 0.23rem;
      }
    }
  }
}
</style>